import React, { useContext } from 'react';

import PropTypes from 'prop-types';
import SkeletonElement from '../components/SkeletonElement';
import { PendingContext } from './withSkeleton';

export default (BaseComponent, skeletonProps) => {
    const Wrapped = ({ theme, isLoading, ...restProps }) => {
        const pending = useContext(PendingContext);

        return pending ? (
            <SkeletonElement { ...skeletonProps } { ...restProps } isLoading={ pending }>
                <BaseComponent { ...restProps } theme={ theme } />
            </SkeletonElement>
        ) : (
            <BaseComponent { ...restProps } theme={ theme } isLoading={ isLoading } />
        );
    };
    Wrapped.propTypes = {
        isLoading: PropTypes.bool,
    };
    return Wrapped;
};
